import isBoolean from 'lodash/isBoolean'
import isEmpty from 'lodash/isEmpty'
import { DEFAULT_COLUMN_VISIBILITY } from '../constants/column'
import { Column } from '../models/column'
import { SettingState } from '../models/settings'

const filteredColumns = (columns: Column[], settings: SettingState) => {
  const resultingColumns = []
  for (let i = 0; i < columns.length; i++) {
    let subColumns = []
    let column = { ...columns[i] }
    if (column.columns?.length) {
      subColumns = filteredColumns(column.columns, settings)
    }
    column.columns = subColumns
    if (
      isEmpty(settings.columns) ||
      isBooleanOrDefault(
        settings?.columns?.[column.field]?.isVisible,
        DEFAULT_COLUMN_VISIBILITY
      )
    ) {
      resultingColumns.push(column)
    }
  }
  return resultingColumns
}

const isBooleanOrDefault = (value, defaultValue) =>
  isBoolean(value) ? value : defaultValue

export default filteredColumns
